import { useTranslation } from '@eti/providers';
import {
  NO_CHECKED_BAGGAGE,
  NO_CHECKED_BAGGAGE_AVAILABLE,
  INCLUDED_CHECKED_BAGGAGE,
} from '../../../../../../constants/includedBaggageConstants';
import { getIncludedBaggageText } from '../../utils';
import Feature from '../Feature';
import type { BaggageFeatureProps } from '../model';

const CheckedBaggageFeature = ({
  shouldShowNotIncludedProducts,
  brandedFareData,
}: BaggageFeatureProps) => {
  const { t } = useTranslation();
  const checkedBaggageSummaries = brandedFareData?.checkedBaggageSummary?.tripSummaries?.[0];
  const checkedBaggageStatus = checkedBaggageSummaries?.baggageStatus;
  const checkedBaggageDetails = checkedBaggageSummaries?.baggageDetails;

  if (
    checkedBaggageStatus &&
    checkedBaggageDetails &&
    checkedBaggageStatus === INCLUDED_CHECKED_BAGGAGE
  ) {
    const checkedInBaggageName = getIncludedBaggageText(
      checkedBaggageDetails,
      'IbeClient.CheckInBaggageIncluded.Label',
      t,
    );

    return (
      <Feature
        isIncluded
        key={`${brandedFareData.id}${checkedInBaggageName}`}
        label={checkedInBaggageName}
      />
    );
  }

  if (
    shouldShowNotIncludedProducts &&
    checkedBaggageStatus &&
    (checkedBaggageStatus === NO_CHECKED_BAGGAGE ||
      checkedBaggageStatus === NO_CHECKED_BAGGAGE_AVAILABLE)
  ) {
    const checkedInBaggageName = t('BrandedFares.CheckInBaggageNotIncluded.Text', 1);

    return (
      <Feature key={`${brandedFareData.id}${checkedInBaggageName}`} label={checkedInBaggageName} />
    );
  }

  return null;
};

export default CheckedBaggageFeature;
